import { CulturalActivity } from "@common/ADAPT.Common.Model/organisation/cultural-activity";
import { CulturalActivityStatus } from "@common/ADAPT.Common.Model/organisation/cultural-activity-status";
import { CulturalActivityType } from "@common/ADAPT.Common.Model/organisation/cultural-activity-type";
import { SurveyType } from "@common/ADAPT.Common.Model/organisation/survey";
import moment from "moment";

export class CulturalActivityExtensions {
    public constructor(private culturalActivity: CulturalActivity) {}

    public get hasRescheduled() {
        return !moment(this.culturalActivity.date).isSame(this.culturalActivity.initialDate, "date");
    }

    public get isOverdue() {
        return moment().isSameOrAfter(this.culturalActivity.date, "date");
    }

    public get activityStatus() {
        return this.isOverdue ? CulturalActivityStatus.Overdue : CulturalActivityStatus.Upcoming;
    }

    public get isSurvey() {
        return !!this.surveyType;
    }

    public get isPeerCatchup() {
        return this.culturalActivity.type === CulturalActivityType.PeerCatchUp;
    }

    public get surveyType() {
        switch (this.culturalActivity.type) {
            case CulturalActivityType.EmployeeEngagementAssessment:
                return SurveyType.EmployeeEngagement;
            case CulturalActivityType.ResilientBusinessAssessment:
                return SurveyType.ResilientBusinessAssessment;
            case CulturalActivityType.TeamAssessment:
                return SurveyType.TeamAssessment;
            default:
                return undefined;
        }
    }

    public getOtherPersonId(currentPersonId?: number) {
        if (this.culturalActivity.person1Id === currentPersonId) {
            return this.culturalActivity.person2Id;
        } else if (this.culturalActivity.person2Id === currentPersonId) {
            return this.culturalActivity.person1Id;
        }

        return this.culturalActivity.person1Id;
    }

    public isInvolvedPerson(personId?: number) {
        return this.culturalActivity.person1Id === personId
            || this.culturalActivity.person2Id === personId;
    }
}
